import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQ = () => {
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate('/');
    // Wait for navigation to complete before scrolling
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const scrollPadding = 10;
        const targetPosition = contactSection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetPosition - headerHeight - scrollPadding,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const faqs = [
    {
      question: "What makes THE PHYT GYM different from other fitness programs?",
      answer: "THE PHYT GYM stands out through our holistic approach to fitness, combining strength training, nutrition coaching, and mindset development. Coach HT's unique methodology focuses on sustainable lifestyle changes rather than quick fixes. We provide personalized programs, ongoing accountability, and a supportive community to ensure long-term success."
    },
    {
      question: "How do I get started with THE PHYT GYM?",
      answer: "Getting started is simple! Choose a membership plan that fits your goals and schedule. You'll receive immediate access to your personalized training program, nutrition guidance, and accountability support. We offer a consultation to assess your current fitness level and create a customized plan that works for your lifestyle."
    },
    {
      question: "What kind of support can I expect from Coach HT?",
      answer: "Our support system includes regular check-ins, text support for quick questions, and comprehensive coaching. Depending on your membership level, you'll have access to nutrition guidance, accountability coaching, virtual consultations, and community support. Coach HT is committed to being there every step of your fitness journey."
    },
    {
      question: "Do I need any special equipment?",
      answer: "Our programs are designed to be flexible and adaptable. While some workouts may include equipment, we provide alternatives for those who don't have access to a full gym. We can modify exercises based on the equipment you have available, ensuring you can complete your workouts effectively at home or in any setting."
    },
    {
      question: "How often should I work out?",
      answer: "The frequency of your workouts depends on your goals, current fitness level, and schedule. Our programs are designed to be flexible, typically ranging from 3-5 days per week. We'll help you find the right balance that works for your lifestyle while ensuring optimal results and recovery."
    },
    {
      question: "What if I have an injury or health condition?",
      answer: "Safety is our top priority. We conduct thorough assessments and can modify programs to accommodate injuries or health conditions. Coach HT has experience working with clients with various limitations and will work with you to create a safe and effective program that considers your specific needs and medical history."
    },
    {
      question: "Can I change my membership plan later?",
      answer: "Yes, you can upgrade or modify your membership plan at any time. We understand that your needs may change, and we're here to support your journey. Contact our support team to discuss your options and find the best plan for your current goals and budget."
    },
    {
      question: "What results can I expect with THE PHYT GYM?",
      answer: "Results vary based on individual factors, including consistency, effort, and starting point. However, our clients typically see noticeable improvements in strength, endurance, body composition, and overall confidence within 4-8 weeks. We focus on sustainable progress and long-term success rather than quick fixes."
    },
    {
      question: "What nutrition guidance do you provide?",
      answer: "Our nutrition coaching includes personalized meal plans, macro tracking guidance, and education on making sustainable food choices. We focus on building healthy habits that fit your lifestyle, preferences, and goals. Coach HT will help you develop a relationship with food that supports your fitness journey."
    },
    {
      question: "Is there a community aspect to THE PHYT GYM?",
      answer: "Yes! We believe in the power of community support. Our members have access to a supportive group where you can connect with others on similar journeys, share progress, and get motivated. The community aspect helps keep you accountable and provides encouragement throughout your fitness journey."
    }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-4xl font-bold text-center mb-12">
              Frequently Asked <span className="text-purple-600">Questions</span>
            </h1>
            
            <div className="space-y-8">
              {faqs.map((faq, index) => (
                <div 
                  key={index}
                  className="bg-gray-50 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
                >
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="text-gray-600 mb-4">
                Still have questions? Coach HT is here to help!
              </p>
              <button
                onClick={handleContactClick}
                className="inline-block bg-purple-600 text-white px-8 py-3 rounded-xl hover:bg-purple-700 transition"
              >
                Contact Us
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FAQ; 